<div class="card">
    <div class="card-header">
        <h3 class="card-header-title">API key</h3>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-12 mb-2">
                <span>Use the token below in the Authorization header to access the Flowmaps API:</span>
            </div>
            <div class="col-12">
                <div class="row align-items-center">
                    <div class="col-11 text-truncate">
                        <span class="fw-bold notranslate">{{ data.secret.basicHeader }}</span>
                    </div>
                    <div class="col-1 text-end">
                        <button class="btn btn-outline-primary" (click)="copyValue(data.secret.basicHeader)"
                                title="Copy header">
                            <i class="bi bi-copy"></i>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-flex justify-content-between">
            <a class="btn btn-secondary" data-bs-dismiss="modal">Close</a>
            <button type="submit" data-bs-dismiss="modal" class="btn btn-primary" (click)="downloadKey()">Download and
                close
            </button>
        </div>
    </div>
</div>
